<template>
  <div class="d-flex align-items-center justify-content-center min-vh-100 bg-white">
    <main class="form-signin w-100 m-auto text-center" style="max-width: 330px; padding: 1rem;">
      <div v-if="!successMessage">
        <form @submit.prevent="handleSendResetEmail">
          <h1 class="h3 mb-3 fw-normal">{{ $t('auth.resetPassword') }}</h1>

          <div class="form-floating mb-3">
            <input type="email" id="email" class="form-control" v-model="email" required placeholder="Email">
            <label for="email">{{ $t('auth.email') }}</label>
          </div>

          <button class="w-100 btn btn-lg btn-primary" type="submit" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
            {{ $t('auth.sendResetLink') }}
          </button>

          <div v-if="errorMessage" class="alert alert-danger mt-3">
            {{ errorMessage }}
          </div>
        </form>
      </div>

      <div v-else>
        <div class="alert alert-success">
          {{ successMessage }}
        </div>
        <p class="mt-4 text-muted">
          <router-link to="/signin">{{ $t('auth.backToSignIn') }}</router-link>
        </p>
      </div>

      <p class="mt-5 mb-3 text-muted">&copy; 2026 kikuflow</p>
    </main>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { getAuth, sendPasswordResetEmail } from 'firebase/auth'

const { t } = useI18n()

const auth = getAuth()

const email = ref('')
const loading = ref(false)
const errorMessage = ref('')
const successMessage = ref('')

const handleSendResetEmail = async () => {
  loading.value = true
  errorMessage.value = ''
  successMessage.value = ''

  try {
    if (!email.value) {
      errorMessage.value = t('auth.errors.emailRequired')
      return
    }
    await sendPasswordResetEmail(auth, email.value)
    successMessage.value = t('auth.resetEmailSent')
  } catch (error: any) {
    // Firebase 會對所有 Email 都回傳成功訊息，以避免洩漏用戶資訊
    // 所以這裡不需要特別處理錯誤，直接顯示成功訊息即可
    successMessage.value = t('auth.resetEmailSent')
  } finally {
    loading.value = false
  }
}
</script>
